
// Error Message Component (Pure UI)
export function ErrorMessage({ error }) {
  if (!error) {
    return null;
  }
  return (
  // Using Tailwind class mt-1 text-sm font-medium and inline style for color
    <p style={{ color: '#ef4444' }} className="mt-1 text-sm font-medium">
      {error}
    </p>
  );
}
